import { render, staticRenderFns } from "./BasicMediaElement.vue?vue&type=template&id=44d9ed27&scoped=true&"
import script from "./BasicMediaElement.vue?vue&type=script&lang=js&"
export * from "./BasicMediaElement.vue?vue&type=script&lang=js&"
import style0 from "./BasicMediaElement.vue?vue&type=style&index=0&id=44d9ed27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d9ed27",
  null
  
)

export default component.exports